import { DAIMI_PH_INTRO, DAIMI_PH_SLUG } from '@/content/daimiPharmaceuticals'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-seventh report with a designed page of its own, and the twelfth focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the Public Services and Retail cuts before it (*"referans alarak ilgili
  // sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part full-page capture
  // of the live page, the cover as two overlapping 2000px crops, Figure 1 and the
  // report mockup. See `content/daimiPharmaceuticals.ts` and
  // `pages/DaimiPharmaceuticals.tsx`. Not to be confused with the Future 2030
  // Pharmaceutical outlook further down, which is a separate report on
  // `'pharmaceutical-outlook'`.
  ...focus(
    DAIMI_PH_SLUG,
    'Pharmaceuticals',
    'daimi-report-2026-pharmaceuticals-cover',
    '038636cd-8303-453a-b4b5-937e442847ff-digitopia-daimi-2026-report-pharma.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held on
  // the page that says them — so the search result and the page cannot drift apart.
  // `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_PH_INTRO.body,
  layout: 'pharmaceuticals-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiPharmaceuticalsChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 13
